import type { DashboardBackground } from '@atnt/shared';
import { useScene } from './scene';

/**
 * Dashboard background ("Chizma" palette item, §4.2) — inside the stage, `cover` on 1920×1080, zoomed about the
 * centre by `scale`, `opacity` on the media only. Never `cover` on the viewport: markers point
 * at features of this image and must stay aligned (§8.2). The viewer look adds the 14:7285 bottom fade behind
 * the section cards.
 */
export function SceneBackground({ background }: { background: DashboardBackground }) {
  const { variant, mode, fileUrl } = useScene();
  const media = background.media;
  const mediaStyle = {
    opacity: background.opacity,
    transform: background.scale !== 1 ? `scale(${background.scale})` : undefined,
  };
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden bg-primary-bg-1000">
      {media &&
        (media.kind === 'video' ? (
          <video
            key={media.fileId}
            src={fileUrl(media.fileId)}
            className="absolute inset-0 size-full object-cover"
            style={mediaStyle}
            autoPlay={mode !== 'edit'}
            muted
            loop
            playsInline
            preload="auto"
          />
        ) : (
          <img key={media.fileId} src={fileUrl(media.fileId)} alt="" draggable={false} decoding="async" className="absolute inset-0 size-full object-cover" style={mediaStyle} />
        ))}
      {variant === 'viewer' && media && (
        // 14:7407: y 906–1076, linear-gradient(#06174200 0% → #2b383b 60%)
        <div className="absolute inset-x-0 bottom-0 h-174" style={{ background: 'linear-gradient(to bottom, #06174200 0%, #2b383b 60%)' }} />
      )}
    </div>
  );
}
